import { SearchInput } from '@components/SearchInput';
import {
  convertItemToImperial,
  convertItemToMetric,
} from '@page-components/shipment';
import MetricImperialToggle from '@components/MetricImperialToggle';
import { FlexRow, PageHeaderText } from '@elements/Common';
import { useEffect } from 'react';
import type { IPOProduct } from '@hooks/purchase-order-items';

interface IPOTableSearchProps {
  items: IPOProduct[];
  setItems: (items: IPOProduct[]) => void;
  imperial: boolean;
  setImperial: (value: boolean) => void;
  setSearch: (value: string) => void;
  search: string;
  hideImperial?: boolean;
  title?: boolean;
  loading?: boolean;
}

export function POTableSearch({
  items,
  setItems,
  imperial,
  setImperial,
  setSearch,
  search,
  hideImperial,
  title,
  loading,
}: IPOTableSearchProps) {
  useEffect(() => {
    if (imperial) {
      toImperial();
    } else {
      toMetric();
    }
  }, [imperial]);

  const changeUnits = (value: boolean) => {
    setImperial(value);
  };

  const toImperial = () => {
    const _items = items.map(item => {
      item.attributes = item?.attributes?.map(att =>
        convertItemToImperial(att),
      );
      return item;
    });
    setItems(_items);
  };

  const toMetric = () => {
    const _items = items.map(item => {
      item.attributes = item?.attributes?.map(att => convertItemToMetric(att));
      return item;
    });
    setItems(_items);
  };

  return (
    <div className="sk:mt-1 sk:mb-2 sk:flex sk:flex-wrap sk:items-center sk:justify-between sk:gap-2">
      <FlexRow>
        {title && <PageHeaderText>Components</PageHeaderText>}
        {items?.length > 0 && !hideImperial && (
          <MetricImperialToggle
            toggle
            className="sk:mx-3.5!"
            wrapperClassName={title ? 'sk:mx-3.5!' : ''}
            onChange={(_, { checked }) => changeUnits(checked)}
            checked={imperial}
          />
        )}
      </FlexRow>
      <div className="sk:w-full sk:sm:w-1/3">
        <SearchInput
          placeholder="SKU, UPC, Title, ASIN..."
          fluid
          search={search}
          setSearch={setSearch}
          loading={loading}
          disabled={loading}
        />
      </div>
    </div>
  );
}
